import axios from 'axios'
import store from '../store/index'
import router from "@/router";

const calculosEconomia = axios.create({
    baseURL: process.env.VUE_APP_RELATORIO_CALCULOS_ECONOMIA_URL
});

calculosEconomia.interceptors.request.use(async request => {
    request.baseURL = process.env.VUE_APP_RELATORIO_CALCULOS_ECONOMIA_URL
    request.headers['Ocp-Apim-Subscription-Key'] = process.env.VUE_APIM_SUBSCRIPTION_KEY_RELATORIO_CALCULOS_ECONOMIA
    var deveTerLoading = !request.url.split('&').includes('loading=false');

    if (deveTerLoading) {
        store.commit('spinner/toggleSpinner', true)
    }
    return request
})

calculosEconomia.interceptors.response.use(response => {
    store.commit('spinner/toggleSpinner', false)
    return response;
}, error => {
    store.commit('spinner/toggleSpinner', false)

    if (error.response.status && ([400, 403, 500, 401].includes(error.response.status))) {
        router.push({name: 'error', query: {error: error.response.status}})
    }

    console.log('error', error);

    return Promise.reject(error)
})

export default calculosEconomia;



// WEBPACK FOOTER //
// ./src/plugins/CalculosEconomiaInterceptor.js